// export default (process.env.VUE_APP_HUN == 'true' ? {
//   apiKey: "AIzaSyCfVQoCnvaXkz2g__Sfam5FsAEKxfJUYf4",
//   authDomain: "microcanales-cne-df069.firebaseapp.com",
//   databaseURL: "https://microcanales-cne-df069.firebaseio.com",
//   projectId: "microcanales-cne-df069",
//   storageBucket: "microcanales-cne-df069.appspot.com",
//   messagingSenderId: "325692482061",
//   appId: "1:325692482061:web:99b6aa2246c018da75ab44",
//   measurementId: "G-LK9PZT38KY"
// } : {
//   apiKey: "AIzaSyC0SaIrwgrnOFykRpym2SGOqsWP06Tsn4c",
//   authDomain: "microcanales-cne-cze.firebaseapp.com",
//   databaseURL: "https://microcanales-cne-cze.firebaseio.com",
//   projectId: "microcanales-cne-cze",
//   storageBucket: "microcanales-cne-cze.appspot.com",
//   messagingSenderId: "905568812140",
//   appId: "1:905568812140:web:99343b5872d5578a83ec49",
//   measurementId: "G-SBDT8GG2J6"
// })

// export default {
//   apiKey: "AIzaSyBuzoZW5esd9QDzZq2e5LvjL6HTBJfaQHI",
//   authDomain: "amc-mikro-cz.firebaseapp.com",
//   projectId: "amc-mikro-cz",
//   storageBucket: "amc-mikro-cz.appspot.com",
//   messagingSenderId: "118131859100",
//   appId: "1:118131859100:web:43bd05885917560b455759",
//   measurementId: "G-WL7CZLSXLX"
// }

// export default {
//   apiKey: "AIzaSyCfVQoCnvaXkz2g__Sfam5FsAEKxfJUYf4",
//   authDomain: "microcanales-cne-df069.firebaseapp.com",
//   databaseURL: "https://microcanales-cne-df069.firebaseio.com",
//   projectId: "microcanales-cne-df069",
//   storageBucket: "microcanales-cne-df069.appspot.com",
//   messagingSenderId: "325692482061",
//   appId: "1:325692482061:web:99b6aa2246c018da75ab44",
//   measurementId: "G-LK9PZT38KY"
// }

console.log({prod: process.env.VUE_APP_ID})
const config = (process.env.VUE_APP_ID === 'microcanales-cne-df069' ? {
  apiKey: "AIzaSyCfVQoCnvaXkz2g__Sfam5FsAEKxfJUYf4",
  authDomain: "microcanales-cne-df069.firebaseapp.com",
  databaseURL: "https://microcanales-cne-df069.firebaseio.com",
  projectId: "microcanales-cne-df069",
  storageBucket: "microcanales-cne-df069.appspot.com",
  messagingSenderId: "325692482061",
  appId: "1:325692482061:web:99b6aa2246c018da75ab44",
  measurementId: "G-LK9PZT38KY"
} : {
  apiKey: "AIzaSyBuzoZW5esd9QDzZq2e5LvjL6HTBJfaQHI",
  authDomain: "amc-mikro-cz.firebaseapp.com",
  projectId: "amc-mikro-cz",
  storageBucket: "amc-mikro-cz.appspot.com",
  messagingSenderId: "118131859100",
  appId: "1:118131859100:web:43bd05885917560b455759",
  measurementId: "G-WL7CZLSXLX"
})

console.log(config)
export default config